import React from 'react'
import {useIntl} from 'react-intl'
import PropTypes from 'prop-types'
import Chip from '../chip'
import {FilterIcon} from '../icons'

/**
 * Filter & Sort button component
 * @param {object} [chipProps]
 * @param {number} [count]
 * @param {function} [onClick]
 * @returns {JSX.Element}
 * @constructor
 */
const FilterSortButton = ({chipProps, count, onClick}) => {
    const {formatMessage} = useIntl()
    return (
        <Chip
            size="md"
            orderable
            name={formatMessage(
                {
                    id: 'global.filter_and_sort.button.filter',
                    defaultMessage: 'Filter & Sort {count}'
                },
                {
                    count: count ? `(${count})` : ''
                }
            )}
            leftIcon={<FilterIcon boxSize={5} />}
            onChange={onClick}
            {...chipProps}
        />
    )
}

FilterSortButton.propTypes = {
    chipProps: PropTypes.object,
    count: PropTypes.number,
    onClick: PropTypes.func
}

export default FilterSortButton
